import { Routes } from '@angular/router';
import { UsuarioComponent } from './usuario/usuario.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { PontoDashboardComponent } from './ponto-dashboard/ponto-dashboard.component';
import { GuardianDashboardComponent } from './guardian-dashboard/guardian-dashboard.component';
import { CadastroPatrimonioComponent } from './guardian-dashboard/cadastro-patrimonio/cadastro-patrimonio.component';
import { AuthGuard } from './guard/auth.guard';
import { DashboardCadastroComponent } from './guardian-dashboard/dashboard/dashboard-cadastro.component';
import { EstoqueDashboardComponent } from './guardian-dashboard/estoque/estoque-dashboard.component';
import { RedefinirSenhaComponent } from './login/redefinir-senha/redefinir-senha.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'redefinir-senha', component: RedefinirSenhaComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'usuario', component: UsuarioComponent,canActivate: [AuthGuard] },
  { path: 'home', component: HomeComponent ,canActivate: [AuthGuard]},
  { path: 'exbeOn', component: PontoDashboardComponent ,canActivate: [AuthGuard] },
  { path: 'guardian/estoque', component: GuardianDashboardComponent ,canActivate: [AuthGuard]},
  { path: 'estoque', component: EstoqueDashboardComponent , canActivate: [AuthGuard] },
  { path: 'guardian/cadastro-patrimonio', component: CadastroPatrimonioComponent,canActivate: [AuthGuard] },
  { path: 'guardian/dashboard', component: DashboardCadastroComponent,canActivate: [AuthGuard] }

  // outras rotas aqui
];

